module.exports = __webpack_public_path__ + "img/s-ign-logout.8d4736f9.svg";